import { useSearchParams } from 'react-router'
import { useMemo } from 'react'

export function useListParams<
  T extends { public?: boolean; created?: string; title?: string }
>(items: T[]): T[] {
  const [searchParams] = useSearchParams()
  const isPublic = searchParams.has('isPublic')
    ? searchParams.get('isPublic') === 'true'
    : null
  const sort = searchParams.get('sort') ?? 'recent'

  return useMemo(() => {
    let result = [...items]

    if (isPublic !== null) {
      result = result.filter((item) => item.public === isPublic)
    }

    switch (sort) {
      case 'oldest':
        result.sort(
          (a, b) =>
            new Date(a.created).getTime() - new Date(b.created).getTime()
        )
        break
      case 'name_asc':
        result.sort((a, b) => a.title.localeCompare(b.title))
        break
      case 'name_desc':
        result.sort((a, b) => b.title.localeCompare(a.title))
        break
      case 'recent':
      default:
        result.sort(
          (a, b) =>
            new Date(b.created).getTime() - new Date(a.created).getTime()
        )
        break
    }

    return result
  }, [items, isPublic, sort])
}
